import { render } from "./EmailSubscription.vue?vue&type=template&id=06a2bdd8&scoped=true"
import script from "./EmailSubscription.vue?vue&type=script&lang=js"
export * from "./EmailSubscription.vue?vue&type=script&lang=js"

import "./EmailSubscription.vue?vue&type=style&index=0&id=06a2bdd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a2bdd8"]])

export default __exports__